import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const TableReport = ({ salesData, colName, data }) => {
  return (
    <Box
      sx={{
        py: "20px",
        px: { xs: "10px", sm: "50px" },
        background: "white",
        borderRadius: "10px",
      }}
    >
      <Grid container pl={{xs:2, sm:0}} spacing={1}>
        <Grid
          container
          spacing={1}
          // px={20}
          sx={{ borderBottom: "1px solid #1E1E1E", padding: "10px 0px" }}
        >
          <Grid item xs={8}>
            <Typography
              color="primary"
              sx={{
                fontWeight: "500",
                paddingLeft: "50px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Date
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <Typography
              color="primary"
              sx={{
                fontWeight: "500",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Amount
            </Typography>
          </Grid>
        </Grid>

        {/* Header */}

        <Grid container>
          <Grid item xs={12}>
            <Box
              sx={{
                height: "60vh",
                overflowY: "auto",
                background: "#fff",
                paddingRight: "20px",
                borderRadius: "10px",
                my: "10px",
              }}
            >
              {data.map((item, idx) => (
                <Grid
                  container
                  key={idx}
                  elevation={2}
                  sx={{
                    borderRadius: "10px",
                    my: "5px",
                    background: "#E3E3FF",
                    color: "#000000",
                  }}
                >
                  <Grid item xs={8} sx={{ paddingLeft: "40px" }}>
                    <Box p={1}>
                      <Typography
                        fontWeight={500}
                        sx={{
                          // fontWeight: "bold",
                          // marginLeft: "8px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        {convertDateToCustomFormat(
                          item?.billDate?.split("T")[0]
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={4}>
                    <Box p={1}>
                      <Typography
                        fontWeight={500}
                        sx={{
                          // fontWeight: "bold",
                          // marginLeft: "8px",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        ₹&nbsp;&nbsp; {item?.rawMaterialValue?.toFixed(2)}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableReport;
